import { Stack, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { THubstripeCustomer } from "../../../shared/types/hubstripeCustomer.type";
import BillingPaymentMethodsItemsRow from "./BillingPaymentMethodsItemsRow";

type PaymentMethod = {
    id: string;
    [key: string]: any; // ou définis précisément les champs si tu veux
};

type BillingPaymentMethodsItemsTableProps = {
    customer: THubstripeCustomer | null;
    paymentMethods: Record<string, PaymentMethod> | null;
    onPaymentMethodsChange: () => void;
    loadingPaymentMethods: boolean;
    selectedPaymentMethodId?: string | null;
    onSelectPaymentMethod?: (id: string) => void;
}

function BillingPaymentMethodsItemsTable({
    customer,
    paymentMethods,
    onPaymentMethodsChange,
    loadingPaymentMethods,
    selectedPaymentMethodId,
    onSelectPaymentMethod
}: BillingPaymentMethodsItemsTableProps) {

    if (!paymentMethods) return null;

    const paymentMethodsItemsAsArray = Object.keys(paymentMethods)
        .map((pid) => paymentMethods[pid]);

    // Affichage sélectionnable
    if (onSelectPaymentMethod) {
        return (
            <RadioGroup
                name="payment-methods"
                value={selectedPaymentMethodId}
                onChange={(e) => onSelectPaymentMethod(e.target.value)}
            >
                <Stack spacing={1}>
                    {paymentMethodsItemsAsArray.map((paymentMethod) => (
                        <FormControlLabel
                            key={paymentMethod.id}
                            value={paymentMethod.id}
                            control={<Radio />}
                            label={
                                <BillingPaymentMethodsItemsRow
                                    key={paymentMethod.id}
                                    customer={customer}
                                    paymentMethod={paymentMethod}
                                    onPaymentMethodsChange={onPaymentMethodsChange}
                                    loadingPaymentMethods={loadingPaymentMethods}
                                />
                            }
                        />
                    ))}
                </Stack>
            </RadioGroup>
        );
    }

    return (
        <Stack spacing={1}>
            {paymentMethodsItemsAsArray.map((paymentMethod) => (
                <BillingPaymentMethodsItemsRow
                    key={paymentMethod.id}
                    customer={customer}
                    paymentMethod={paymentMethod}
                    onPaymentMethodsChange={onPaymentMethodsChange}
                    loadingPaymentMethods={loadingPaymentMethods}
                />
            ))}
        </Stack>
    );
}

export default BillingPaymentMethodsItemsTable;
